/**
 * Calculate cumulative offset (top or left) of a given HTMLElement relative to a target parent element.
 *
 * @param {HTMLElement | null} element - The HTMLElement to start calculating the offset from.
 * @param {HTMLElement} targetParent - The target HTMLElement to stop calculating the offset at.
 * @param {OffsetDirection} direction - The direction of offset to calculate. Can be either 'top' or 'left'.
 *
 * @returns {number} - The total calculated offset.
 *
 * @throws Will throw an error if targetParent is not found in the hierarchy of the given element.
 */
export function calculateOffset(
    element: HTMLElement | null,
    targetParent: HTMLElement,
    direction: "offsetTop" | "offsetLeft",
): number {
    if (element === targetParent) return 0

    let offset = 0

    while (element) {
        offset += element[direction]
        element = element.offsetParent as HTMLElement

        if (element === targetParent) {
            return offset
        }
    }

    throw new Error("Target parent was not found in the hierarchy of the given element")
}
